import React,{useState, useEffect} from 'react';
import {Inc,ResultSet} from './Inc';
import Ajax from './Ajax';
import Result from './Result';
import Loading from './Loading';
import "./Result.scss";

interface Props {
    uid:string,
    gid:string,
    save(id?:string):void,
    move(str:string,param?:any):void,
}

const Record = (props:Props)=> {
    Ajax.setUid(props.uid);

    const [states,setStates] = useState({
        result:Inc.defaultResultSet(),
        gid:"",
    });

    const load = (gid:string)=>{
        Ajax.send("play/result",{gid:gid},(res:any)=>{
            if( res.ok ){
                const result:ResultSet = {
                    story:res.story,
                    play:res.play,
                    is_suki:res.is_suki,
                }
                if( res.uid && res.uid!=="" && res.uid!==props.uid ){
                    props.save(res.uid);
                }
                setStates({...states,gid:gid,result:result});
            } else {
                props.move("top");
            }
        })
    };

    useEffect( ()=>{
        load(props.gid);
    },[]);

    if(states.gid===""){
        return (
            <Loading isLoading={true}/>
        )
    }

    return (
        <Result uid={props.uid} move={props.move} result={states.result}/>
	);
}

export default Record;